/**
 *   Name: Utility.js
 * Author: Francisco J. O'Meany
 * Description: Utility class component for all applications developed by Netequal Technology Solutions & Vysel
 *
 * Copyright (c) 2024 - Netequal Technology Solutions
 *
 */
import React, { useEffect, useState } from 'react';
import jQuery from 'jquery';
import * as Settings from '../../Settings.js';

class Utility extends React.Component {
    constructor(props) {
        super(props);

        const select = (el, all = false) => {
            el = el.trim()
            if (all) {
                return [...document.querySelectorAll(el)]
            } else {
                return document.querySelector(el)
            }
        }

        const on = (type, el, listener, all = false) => {
            let selectEl = select(el, all)
            if (selectEl) {
                if (all) {
                    //- Select each element and set a listener for each event
                    selectEl.forEach(e => 
                        type.forEach( event => 
                            e.addEventListener(event, listener)
                        )
                    );
                } else {
                    selectEl.addEventListener(type, listener)
                }
            }
        }

        this.select     = select;
        this.on         = on;
        this.logObj     = ( typeof console !== "undefined" ? console : window.console );
        this.logSwitch  = this.getCookie('AppDebugger');
        this.logSwitch  = this.logSwitch === undefined ? "off" : this.logSwitch;
        this.logStatus  = ( this.logSwitch.toLowerCase() === "on" ? "enabled" : "disabled" );
        this.appLogger();
    }
    initialize = () => {
        useEffect(()=>{
            this.appLogger('Initialize(): We are in useEffect function');
        
            let links = document.querySelectorAll('a[href*="#"]');    //- Hide hash + ref
            links.forEach(link => {
                link.addEventListener('click', () => {
                    setTimeout(function() {
                        window.history.pushState(document.html, document.title, document.URL.split('#')[0]);
                    }, 1);
                });
            });
        },[]);
    }
    validateEmail = ( email ) => {
        let rEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return rEx.test( email );
    }
    //-----------------------------------------------------------//
	//-- getLocalStorageItem()
	//-----------------------------------------------------------//
    /*
    getLocalStorageItem = ( item ) => {
        let [appDirs, setAppDirs] = useState( [] );
        let localDir = "";
    
        useEffect(() => {
            appDirs = JSON.parse(localStorage.getItem('appDirs'));
            if (appDirs) {
                setAppDirs(appDirs);
                localDir = appDirs[item];
                return( localDir );
            }
        }, []);

    }
    */

    getLocalStorageItem = ( item ) => {
        const [appDirs, setAppDirs] = useState( [] );
    
        useEffect(() => {
            const appDirs = JSON.parse(localStorage.getItem('appDirs'));
            if (appDirs) {
                setAppDirs(appDirs);
                return( appDirs[item] );
            }
        }, [appDirs, item]);

    }



    //-----------------------------------------------------------//
	//-- appBlockUI()
	//-----------------------------------------------------------//
    appBlockUI = () => {
        const isDlg = ( document.getElementById( "appDialogBox" ) === null ? false : true );
        const spinLocation = ( isDlg ? "#" + Settings.APP_DLG_ID : "body" );
        jQuery( 'body' ).css( {"pointer-events":"none", "opacity":"0.4"} );

        this.addSpinner( Settings.APP_SPINNER_ID, spinLocation );

        if( isDlg ) {
            jQuery( "#" + Settings.APP_DLG_ID + " .modal-content" ).css( "pointer-events", "none" );
            jQuery( "#" + Settings.APP_SPINNER_ID ).css({"left":"50%", "position":"absolute"})
        }
    }
    //-----------------------------------------------------------//
	//-- appUnBlockUI()
	//-----------------------------------------------------------//
    appUnBlockUI = () => {
        jQuery( 'body' ).css( {"pointer-events":"all", "opacity":"inherit"} );
        jQuery( "#" + Settings.APP_DLG_ID + " .modal-content" ).css( "pointer-events", "all" );
        this.removeSpinner( Settings.APP_SPINNER_ID );
    }
    //-----------------------------------------------------------//
	//-- addSpinner()
	//-----------------------------------------------------------//
    addSpinner = ( spinId, addTo ) => {
        jQuery( addTo ).append( "<div id='"+spinId+"' class='fa-3x text-center'><i class='fas fa-spinner fa-spin position-absolute' style='top:40%'></i></div>" );
        return( true );
    }
    //-----------------------------------------------------------//
	//-- removeSpinner()
	//-----------------------------------------------------------//
    removeSpinner = ( spinId ) => {
        jQuery( "#" + spinId ).remove();
    }
    //-----------------------------------------------------------//
	//-- getDigitsOnly()
	//-----------------------------------------------------------//
	getDigitsOnly = ( value ) => {
		let retString = '';
		
		for( let i=0; i < value.length; i++ ) {
			if( !isNaN( value.substr( i, 1 ) ) && value.substr( i, 1 ) !== ' ') {
				retString += value.substr( i, 1 );
			}
		}
		return retString;
	}
    //-----------------------------------------------------------//
    //-- getCookie()
    //-----------------------------------------------------------//
    getCookie( c_name ) {
        let i,x,y,ARRcookies=document.cookie.split(";");
        
        for (i=0;i<ARRcookies.length;i++)
        {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x === c_name) {
            return decodeURI(y);
        }
        }
        return;
    }
    //-----------------------------------------------------------//
    //-- setCookie()
    //-----------------------------------------------------------//
    setCookie( c_name, value, exdays ) {
        let exdate = new Date();
        let domain = ( document.location.host.indexOf("localhost") === -1 ? document.location.host : "localhost" );
        let c_value = "";
        
        if( exdays === -1 ) {
            exdate.setHours( +12 );
        } else {
            exdate.setDate(exdate.getDate() + exdays);
        }
        
        if( domain === "" ) {
            c_value = encodeURIComponent(value) + ((exdays==null) ? "" : "; expires=" + exdate.toUTCString()) + "; path=/";
        } else {
            c_value = encodeURIComponent(value) + ((exdays==null) ? "" : "; expires=" + exdate.toUTCString()) + "; path=/; SameSite=None; domain=" + domain + "; Secure";
        }
        document.cookie = c_name + "=" + c_value;
        return;
    }
    //-----------------------------------------------------------//
	//-- setDebug()
	//-----------------------------------------------------------//
	setDebug( state ) {
        this.setCookie( "AppDebugger", state, 1 );
        document.location.reload();
        return( true );
    }
    //-----------------------------------------------------------//
	//-- appLogger()
	//-----------------------------------------------------------//
	appLogger( logStr = null, value = null ) {
        if( logStr === null ) {
            this.logObj.log( "Log Facility is " + this.logStatus );
        }

        if( this.logStatus === "enabled" && logStr !== null ) {
            this.logObj.log( logStr, value );
        }

		return( true );
	}
    //-----------------------------------------------------------//
	//-- getAccount()
	//-----------------------------------------------------------//
    getAccount() {
        const url_string = window.location.href;
        const url = new URL(url_string);
        url.href = url.href.toLowerCase();
        const acct = url.searchParams.get("acct");

        return( acct );
    }

    render() {
        return(<div></div>);
    }
}

export default Utility;